export default "__VITE_ASSET__6b7b4b6a__"